import { Ico } from "@kit-v5";
import { apiFetch } from "./client";
// синонимы: паспорта продуктов называют иконки по смыслу (users/briefcase/settings/sitemap/
// calendar), кит отдаёт их под своими короткими id — без алиаса резолв падал на fallback,
// и рельс/меню рисовали одинаковый квадрат для всех продуктов.
const ICON_ALIASES = {
    users: "team", briefcase: "network", settings: "cog", sitemap: "network", calendar: "cal",
};
// правило 3 контракта: неизвестный icon-id не роняет меню — запасной узел
// на продукт (store) и на пункт меню (doc), резолв делает клиент, не экран.
function resolveIcon(id, fallback) {
    if (id && id in Ico)
        return Ico[id];
    if (id && id in ICON_ALIASES)
        return Ico[ICON_ALIASES[id]];
    return Ico[fallback];
}
function mapItem(it) {
    const submenu = it.submenu?.sections ? { sections: it.submenu.sections.map(mapSection) } : undefined;
    return { id: it.id, label: it.label, icon: resolveIcon(it.icon, "doc"), count: it.count, disabled: it.disabled, ...(submenu ? { submenu } : {}) };
}
function mapSection(s) {
    return { title: s.title, items: (s.items ?? []).map(mapItem) };
}
function mapMenu(m, productId) {
    return { title: m.title, sub: m.sub, sections: (m.sections ?? []).map(mapSection), productId };
}
function mapProduct(p) {
    return {
        id: p.id, product: p.product, label: p.label, icon: resolveIcon(p.icon, "store"),
        order: p.order, count: p.count, status: p.status, version: p.version, section: p.section, role: p.role,
        hasMenu: p.has_menu, tabs: p.tabs, sections: p.sections,
    };
}
export async function getInstalledProducts() {
    const list = await apiFetch("/api/products");
    return (list ?? []).map(mapProduct);
}
export async function getProductMenu(productId) {
    const raw = await apiFetch(`/api/products?id=${encodeURIComponent(productId)}`);
    return mapMenu(raw, productId);
}
export async function openProduct(productId) {
    return apiFetch(`/api/products?id=${encodeURIComponent(productId)}`, { method: "POST" });
}
